module.exports = __webpack_public_path__ + "media/vb.50d258d9.webm";